import React, { useCallback, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import MiniForm from 'components/MiniForm';

import AdditionalDocumentsDropZone from 'components/AdditionalDocumentsDropZone';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateAdditionalDocuments, useOrder } from 'hooks/useOrders';
import { STATUS_WHERE_USER_CAN_ADD_DOCUMENTS } from 'utils/order/constants';

const AdditionalDocuments = ({
  className,
  orderId,
  documents,
  orderStatus,
  isRecurring,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('AdditionalDocuments');
  const { mutate } = useOrder(orderId, isRecurring);

  const handleSubmit = useCallback(
    async ({ files }) => {
      await updateAdditionalDocuments(
        { additionalDocuments: files, orderId },
        dispatch
      );
      mutate();
    },
    [dispatch, orderId, mutate]
  );

  const canUploadFiles = useMemo(
    () => STATUS_WHERE_USER_CAN_ADD_DOCUMENTS.includes(orderStatus),
    [orderStatus]
  );

  if (!canUploadFiles) {
    return null;
  }

  return (
    <div className={className} data-testid="additional-documents">
      <MiniForm
        value={documents?.length > 0}
        id="additional_documentation"
        toEditLabel={t('add_doc')}
        overrideEditField={
          <AdditionalDocumentsDropZone
            files={documents}
            onSubmit={handleSubmit}
            canUploadFiles
          />
        }
      />
    </div>
  );
};

AdditionalDocuments.propTypes = {
  className: PropTypes.string,
  orderId: PropTypes.string.isRequired,
  orderStatus: PropTypes.string.isRequired,
  documents: PropTypes.array,
  isRecurring: PropTypes.bool,
};

AdditionalDocuments.defaultProps = {
  isRecurring: false,
};

export default AdditionalDocuments;
